import React from "react";
import websiteData from '../data.json';
import CoverHeaderXs from '../components/header/cover-header-xs';
import SectionContainer from '../components/containers/section-container';
import GenericParagraph from '../components/paragraphs/Paragraph';
import { Row, Col } from 'react-bootstrap';
import Heading3 from '../components/titles/Heading3';
import Heading1 from '../components/titles/Heading1';
import GoogleMaps from '../components/ga-maps/map';
import GenericList from '../components/lists/generic-list';
import SimpleForm from '../components/form/form';
import ReactGA from 'react-ga';

export const initGA = () => {
    /* console.log('Ga init'); */
     ReactGA.initialize('UA-90162173-1'); 
}

export const logPageView = () => {
    /* console.log(window.location.pathname); */
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
}

/* post the form data - script inserts into db and sends an email to the designated address */
const showResults = function(values) {
  fetch('http://bttsd.com/contact-me.php', {
  method: 'POST',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(values)
  
})
  .then(function(response) {
    document.getElementById('success-send').style.display = 'block';
  })
};


export default class ContactPage extends React.Component {
    componentDidMount() {
        initGA();
        logPageView();
    }
    render() {
        const contactPage = websiteData.contactPage,
              dataCoverHeaderXs = contactPage.CoverHeaderXs[0],
              dataContactWeHire = contactPage.ContactWeHire,
              dataContactWeHireParagraph = contactPage.ContactWeHireParagraph,
              dataContactGetInTouch = contactPage.contactGetInTouch,
              dataContactContactInfo = contactPage.contactContactInfo,
              dataContactContactInfoList = contactPage.contactContactInfoList,
              dataMapDetails = contactPage.mapDetails,
              dataContainerStyle = contactPage.containerStyle,
              dataElementStyle = contactPage.elementStyle,
              dataSubmitButtonName = contactPage.submitButtonName,
              dataFormDataSucessMessage = contactPage.formDataSucessMessage,
              dataFormData = contactPage.formData;   
        return (
            <div id="page">
                <CoverHeaderXs backgroundImage={ dataCoverHeaderXs.headerBackgroundImage } headerSizeClass={ dataCoverHeaderXs.headerSizeClass } headerTitle={ dataCoverHeaderXs.headerTitle } headerSubTitle={ dataCoverHeaderXs.headerSubTitle }/>
                <div className="gtco-section contact">
                    <SectionContainer>
                        <Heading1 title={ dataContactWeHire } />
                        <GenericParagraph text= { dataContactWeHireParagraph } />
                    </SectionContainer>
                </div>
                <div className="gtco-section">
                    <SectionContainer>
                        <Row>
                            <Col md={6}>
                                <Heading3 title={ dataContactGetInTouch } />
                                <SimpleForm onSubmit={showResults} submitButtonName={ dataSubmitButtonName } formData={ dataFormData } formDataSucessMessage={ dataFormDataSucessMessage }/>
                            </Col>
                            <Col md={5} mdPush={1}>
                                <div className="gtco-contact-info">
                                    <Heading3 title={ dataContactContactInfo } />
                                    <GenericList items={ dataContactContactInfoList } />
                                    <GoogleMaps mapData={ dataMapDetails } containerStyle={ dataContainerStyle } elementStyle={ dataElementStyle }/>                                                                           
                                </div>
                            </Col>                            
                        </Row>
                    </SectionContainer>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/contact-page.js